<template>
    <div class="base-milestone-list-container">
        
        <milestone 
            v-for="(milestone) in milestones"
            :key="milestone.index"
            :milestone="milestone">
        </milestone>

    </div>
</template>


<style lang="scss" scoped>
.base-milestone-list-container {
  height: 100%;
  width: 100%;

  overflow: auto;
  background: #eee;
}
</style>


<script>
import { mapGetters, mapActions } from "vuex";

import Milestone from "./subComponents/Milestone";

export default {
  components: {
    milestone: Milestone
  },
  computed: {
    ...mapGetters("processModule", ["activeProcess"])
  },
  watch: {
    activeProcess: {
      immediate: true,
      handler: function() {
        this.updateList(this.activeProcess);
      }
    }
  },
  data() {
    return {
      milestones: null
    };
  },
  methods: {
    ...mapActions({ selectStep: "processModule/setActiveStep" }),
    updateList(newProcess) {
      // TODO replece when proper Milestones are fetched
      this.milestones = [];
      let currentMilestone = {
        steps: [],
        name: "",
        collapsed: true
      };
      let stepIndex = 0;
      for (const step of newProcess.steps) {
        step.index = stepIndex;
        stepIndex += 1;
        if (step.milestone) {
          if (currentMilestone.steps.length !== 0) {
            this.milestones.push(currentMilestone);
          }
          currentMilestone = {
            steps: [],
            name: "",
            collapsed: true
          };
          currentMilestone.name = step.milestone;
        }
        currentMilestone.steps.push(step);
      }
      if (currentMilestone.steps.length !== 0) {
        this.milestones.push(currentMilestone);
      }
      this.selectStep(this.milestones[0].steps[0]);
      this.milestones[0].collapsed = false;
    }
  }
};
</script>
